module.exports = __webpack_public_path__ + "media/images/admin/icons/monitor-cd5cd51c1dc1a8dc962dd3014aae0471.svg";